module.exports = __webpack_public_path__ + "static/media/step1.be2f4ee9.png";